export { GetDocumentAttachmentKindsDocument } from './documentAttachmentKinds/kinds.gql';
